<template>
    <div class="comrade-list-section">
        <!-- 10战友故事 -->
        <van-row @click="goDetail(dataItem)">
            <div v-if="dataItem.content.type === 1" class="comrade-list-section-box">
                <div class="comrade-list-section-left">
                    <van-image
                        fit="cover"
                        class="comrade-list-section-left-img"
                        :src="dataItem.content.cover_img"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="comrade-list-section-right">
                    <div class="comrade-list-section-right-title" v-html="dataItem.content.title"></div>
                </div>
                <div class="clear"></div>
                <div class="comrade-list-section-stats">
                    <img src="/static/bytx/companion_list_read_icon.svg" alt="" />
                    <span>{{ dataItem.content.view_count }}</span>
                    <img src="/static/bytx/companion_list_helpful_icon.svg" alt="" />
                    <span>{{ dataItem.content.like_count }}</span>
                    <img src="/static/bytx/companion_list_comment_icon.svg" alt="" />
                    <span>{{ dataItem.content.comment_count }}</span>
                </div>
                <div class="clear"></div>
            </div>
            <div class="comrade-list-section-box" v-else style="width: auto">
                <div class="comrade-list-section-title" style="padding-right: 14px">
                    {{ dataItem.content.title }}
                </div>
                <van-image
                    fit="cover"
                    class="comrade-list-section-left-img"
                    :src="dataItem.content.cover_img"
                    width="100%"
                    height="100%"
                    style="margin-right: 14px"
                />
                <!--            <div class="comrade-list-section-left-zl">-->
                <!--              {{ dataItem.type_text }}-->
                <!--            </div>-->
                <img class="comrade-list-section-play-btn" src="/static/bytx/list_video_play_2.svg" alt="" />
                <div class="comrade-list-section-stats">
                    <img src="/static/bytx/companion_list_read_icon.svg" alt="" />
                    <span>{{ dataItem.content.view_count }}</span>
                    <img src="/static/bytx/companion_list_helpful_icon.svg" alt="" />
                    <span>{{ dataItem.content.like_count }}</span>
                    <img src="/static/bytx/companion_list_comment_icon.svg" alt="" />
                    <span>{{ dataItem.content.comment_count }}</span>
                </div>
                <div class="clear"></div>
            </div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    methods: {
      goDetail(dataItem) {
        this.$router.push({ name: 'comrade-detail', params: { id: dataItem.content.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.mFootPrint(dataItem.id,67,this.contentType,1,0,0,0,dataItem.content.title, this.searchText)
      }

    }
}
</script>

<style lang="scss" scoped>
.comrade-list-section {
    // padding: 0 12px 15px;
    // padding-bottom: 0;

    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-box {
        width: 345px;
        position: relative;
        // padding: 18px 0 0 0;
        border-bottom: 1px solid #f2f2f2;
        padding-bottom: 15px;
        border: 0;
        padding-bottom: 0;
    }

    .comrade-list-section-title {
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #222222;
        letter-spacing: 0;
        font-weight: 500;
        margin-bottom: 10px;
        .light {
            color: #0fb7ad;
        }
    }

    .comrade-list-section-play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &-left {
        width: 112px;
        height: 66px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 219px;
        text-align: left;

        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            margin-top: 6px;
            .light {
                color: #0fb7ad;
            }
        }

        &-desc {
            font-family: PingFangSC-Regular;
            line-height: 18px;
            margin-top: 9px;
            font-size: 12px;
            color: #9d9d9d;
            text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            overflow: hidden;
        }
    }

    &-stats {
        margin-top: 10px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #8a8b90;
        letter-spacing: 0;
        img {
            margin-bottom: -3px;
        }
        span {
            margin-right: 16px;
        }
    }

    &.group {
        background-color: #f6f6f7;
        padding-top: 11px;
        .comrade-list-section-box {
            background: #fff;
            box-shadow: 0 2px 18px -6px rgba(157, 157, 157, 0.16);
            border-radius: 8px;
            padding: 10px;
            box-sizing: border-box;
            margin-top: 11px;
            &:nth-child(1) {
                margin-top: 0;
            }
            .comrade-list-section-left {
                width: 64px;
                height: 64px;
                img {
                    width: 64px;
                    height: 64px;
                }
            }
        }
    }

    .comrade-list-section-btn {
        float: right;
        width: 76px;
        height: 28px;
        line-height: 28px;
        margin-top: 6px;
        margin-right: 0px;
        margin-bottom: 0px;
        //padding: 5px 14px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        background: #16d2c2;
        border-radius: 16px;
    }

    .comrade-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 2px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }

    .comrade-list-section-left {
        width: 130px;
        height: 73px;
    }
    .comrade-list-section-right {
        width: 190px;
        margin-left: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/comrade.vue